import type { LocaleCodes } from '@_/static';
import { BigNumber } from 'bignumber.js';
import { Duration } from 'luxon';

export const SharedConfig = {
  address: {
    line1MaxLength: 100,
    line2MaxLength: 100,
    localityMaxLength: 100,
    postalCodeMaxLength: 20
  },

  booking: {
    /* Booking cut-off time before a lesson starts */
    bookingCutoff: Duration.fromObject({ minutes: 30 }),

    maxLessonsPerOrder: 50
  },

  cookies: {
    locale: 'locale'
  },

  course: {
    maxImages: 20,
    maxTopics: 3,
    nameMaxLength: 100,
    descriptionMaxLength: 5000
  },

  customer: {
    addressMaxLength: 250,
    nameMaxLength: 100
  },

  defaultCurrency: 'hkd',
  defaultLocale: 'zh-HK' satisfies (typeof LocaleCodes)[number],

  identity: {
    maxPerUser: 6
  },

  lesson: {
    // Max number of lessons that can be created in a single operation
    maxBatchSize: 250,

    minDuration: Duration.fromObject({ minutes: 5 }),
    maxDuration: Duration.fromObject({ hours: 24 }),

    // How far out they can schedule future lessons
    maxScheduleWindow: Duration.fromObject({ months: 12 }),

    maxSpots: 100,
    meetingPasswordMaxLength: 100
  },

  maxLength: {
    authorizationHeader: 1000,
    email: 254,
    searchTerm: 100,
    token: 1000,
    uploadFileName: 50,
    url: 2000
  },

  note: {
    contentMinLength: 1,
    contentMaxLength: 5000
  },

  organization: {
    nameMaxLength: 100,
    descriptionMaxLength: 5000
  },

  payment: {
    maxPaymentMethods: 10,

    minAmount: {
      amount: BigNumber('5'),
      currency: 'hkd'
    }
  },

  password: {
    minLength: 8,
    maxLength: 128
  },

  post: {
    maxTags: 5,
    maxTextPostImages: 8
  },

  pricing: {
    lessonPriceRange: [
      {
        amount: BigNumber('0'),
        currency: 'hkd'
      },
      {
        amount: BigNumber('10000'),
        currency: 'hkd'
      }
    ] as const
  },

  review: {
    contentMinLength: 10,
    contentMaxLength: 5000,
    maxImages: 10
  },

  reviewReply: {
    contentMinLength: 10,
    contentMaxLength: 5000
  },

  room: {
    nameMaxLength: 30
  },

  staff: {
    nameMaxLength: 100,
    descriptionMaxLength: 5000
  },

  tag: {
    maxLength: 30
  },

  user: {
    nameMaxLength: 100,
    descriptionMaxLength: 5000
  },

  vanityName: {
    updateWindow: Duration.fromObject({ days: 60 }),
    minLength: 2,
    maxLength: 30
  },

  venue: {
    maxImages: 20,
    maxRooms: 200,
    maxSpots: 100,
    nameMaxLength: 100,
    descriptionMaxLength: 5000
  }
} as const;
